class ContributionsReactRecurringRecord extends React.Component {

    constructor(props) {
        super(props);
        this.initialLoad = true;
        this._recurringIndex = 0;
        this._warnedRecurringChange = false;
        this.state = {
            recurrings: [],
            originalFee: null,
            fee: null,
            canHaveFee: false,
            recurringTypeOptions: [],
            recurringTypeLabel: props.recurringTypeLabel,
            paymentMethodLabel: props.paymentMethodLabel,
            lockedCategoryIds: props.lockedCategoryIds,
            paymentMethodOptions: [],
            isPayPal: false
        };
    }

    _error(message) {
        new SS.customAlert({
            title: 'Error',
            msg: message,
            closeButton: true,
            buttons: {
                ok: {
                    btnText: 'Ok',
                    btnCls: false,
                    overCls: false
                },
                cancel: false
            }
        });
    }

    //React 16.9 warnings -> https://scotch.io/bar-talk/whats-new-in-react-169
    UNSAFE_componentWillUpdate(nextProps, nextState){
        // If Recurring Type was changed
        if(this.state.recurringType !== nextState.recurringType && nextState.recurringTypes) {
            var nextRecurringTypeArr = nextState.recurringType.split("-");

            var recurringTypeLabel = this.props.recurringTypeLabel;

            // Find label/display value for Recurring Type and update state for it
            nextState.recurringTypes.forEach(function(item){
                var type = item.ContributionRecurringType;
                if(type.interval == nextRecurringTypeArr[0] && type.period == nextRecurringTypeArr[1]){
                    recurringTypeLabel = type.label;
                }
            });

            this.setState({
                recurringTypeLabel: recurringTypeLabel
            });
        }

        // If Payment Method was changed
        if(this.state.paymentMethodId !== nextState.paymentMethodId && nextState.paymentMethods) {
            var paymentMethodLabel = this.props.paymentMethodLabel;

            // Find label/display value for Payment Methods and update state for it
            nextState.paymentMethods.forEach(function(item){
                if(item.PaymentProcessorMethod && item.PaymentProcessorMethod.id == nextState.paymentMethodId){
                    paymentMethodLabel = this.getPaymentMethodDisplayValue(item);
                }
            }.bind(this));

            this.setState({
                paymentMethodLabel: paymentMethodLabel
            });
        }
    }

    componentDidMount(){
        var me = this;
        var fixZIndex = function (input) {
            setTimeout(function () {
                let uiDatePicker = $('.ui-datepicker');
                let style = uiDatePicker.attr('style');
                let regex = /z-index:.\d*/gm;
                if (style) {
                    let replace = style.replace(regex, 'z-index: 900 !important');
                    uiDatePicker.attr('style', replace);
                }
            }, 300);
        };

        $(this.refs.nextRunDate).datepicker({
            beforeShow:fixZIndex,
            minDate:0,
            onSelect: function () { 
                me.setState({nextRunDate:this.value});
            } 
        });
        $(this.refs.endDate).datepicker({
            beforeShow:fixZIndex,
            onSelect: function () {
                me.setState({endDate:this.value});
            }
        });
        
        this.loadOptions();
    }

    loadOptions(){
        var me = this;

        $.ajax({
            url: SS.route('Contributions','ContributionRecurringTypes','getAll'),
            method: 'POST',
            dataType: 'json',
            cache: false,
            success: (function (data) {
                if (data.records) {

                    var recurringTypeOptions = [];

                    data.records.forEach(function(item){
                        var type = item.ContributionRecurringType;

                        recurringTypeOptions.push(
                            <a className="dropdown-item" onClick={me.onRecurringChange.bind(me, type.interval+'-'+type.period)} key={type.id}>{type.label}</a>
                        );
                    });

                    me.setState({
                        recurringTypes: data.records, // for getting label/display value out if ID
                        recurringTypeOptions: recurringTypeOptions
                    });
                } else if (data.errorInfo) {
                    this._error(data.errorInfo);
                }
            }).bind(this),
            error: (function (xhr, status, err) {
                this._error('Unknown error occurred');
            }).bind(this)
        });

        $.ajax({
            url: SS.route('PaymentProcessors','PaymentProcessorMethods','getAll',null),
            method: 'POST',
            dataType: 'json',
            cache: false,
            success: (function (data) {
                if (data.records) {

                    var paymentMethodIds = [];
                    var paymentMethodOptions = [];

                    data.records.forEach(function(item){
                        var method = item.PaymentProcessorMethod;

                        // Collect all Payment Methods for current user
                        paymentMethodIds.push(method.id);

                        paymentMethodOptions.push(
                            <a className="dropdown-item" data-currency={method.currency} onClick={me.onMethodChange.bind(me, method)} key={method.id}>{me.getPaymentMethodDisplayValue(item)}</a>
                        );
                    });

                    this.setState({
                        paymentMethods: data.records,
                        paymentMethodOptions: paymentMethodOptions,
                        paymentMethodIds: paymentMethodIds
                    }, function(){
                        if(this.props.editRecurringBatchId && this.initialLoad){
                            this.initialLoad = false;
                            this.show(this.props.editRecurringBatchId);
                        }
                    });

                } else if (data.errorInfo) {
                    this._error(data.errorInfo);
                }
            }).bind(this),
            error: (function (xhr, status, err) {
                this._error('Unknown error occurred');
            }).bind(this)
        });
    }

    isValidDate(date) {
        var bits = date.split('-');
        var d = moment(bits[0] + '/' + bits[1] + '/' + bits[2], 'YYYY-MM-DD');
        return d.isValid();
    }

    formatDate(format, date){
        if(format && date) {
            var bits, y, m, d;

            // If date contains - or /
            if(date.indexOf("-") >= 0){
                bits = date.split('-');
                y = parseInt(bits[0]);
                m = parseInt(bits[1]);
                d = parseInt(bits[2]);
            } else {
                bits = date.split('/');
                y = parseInt(bits[2]);
                m = parseInt(bits[0]);
                d = parseInt(bits[1]);
            }

            var newDateString = y + '-' + m + '-' + d;
            var newDate = moment(newDateString, 'YYYY-MM-DD');

            return !!(newDate && newDate.year() == y && (newDate.month() + 1) == m && newDate.date() == Number(d)) ?
                $.datepicker.formatDate(format, $.datepicker.parseDate('yy-mm-dd', newDateString)) : undefined;
        }

        return '';
    }

    load(id){
        var state = this.state;

        $.ajax({
            url: SS.route('Contributions', 'ContributionRecurringBatches', 'getAll'),
            data: {
                id: id,
                hasMany:1,
                showCampaignInfo: 1
            },
            method: 'POST',
            dataType: 'json',
            cache: false,
            success: (function (data) {
                if (data.records) {
                    var record = data.records[0];
                    if(record){

                        var paymentMethodId = record.ContributionRecurringBatch.payment_processor_method_id;
                        var paymentRecord = record.PaymentProcessorMethod;

                        // If saved Payment Method is missing from list of available Payment Methods for current user
                        if(jQuery.inArray(paymentMethodId, state.paymentMethodIds) == -1) {
                            // Set payment method to null if it's not valid
                            paymentMethodId = null;
                            paymentRecord = null;
                        }


                        // If payment method has just been added - select it
                        if(this.props.editRecurringBatchId && state.paymentMethods.length > 0){
                            // Get last payment method saved to database (last in the array of all payment methods)
                            var lastPaymentMethod = state.paymentMethods[state.paymentMethods.length - 1];

                            // If last payment method was created in last 5 minutes
                            if(new Date() - new Date(lastPaymentMethod.PaymentProcessorMethod.created.replace(/-/g, '/')) < 5 * 60 * 1000) {
                                paymentMethodId = lastPaymentMethod.PaymentProcessorMethod.id;
                                paymentRecord = lastPaymentMethod.PaymentProcessorMethod;
                            }
                        }

                        var isPayPal = false;
                        if (paymentRecord && paymentRecord.type == 'paypal') {
                            paymentMethodId = paymentRecord.id;
                            isPayPal = true;
                        }

                        var recurrings = this.formatRecurrings(record.ContributionRecurring);

                        // Calculate total after the load
                        var total = 0;
                        recurrings.forEach(function(item){
                            var amount = parseFloat(item.amount);
                            if(!isNaN(amount)){
                                total+=amount;
                            }
                        });

                        this.setState({
                            loading:false,
                            person:record.AffiliatedPerson.id?record.AffiliatedPerson:record.Person,
                            startDate:this.formatDate('mm/dd/yy', record.ContributionRecurringBatch.recurring_start_date),
                            endDate:this.formatDate('mm/dd/yy', record.ContributionRecurringBatch.recurring_end_date),
                            nextRunDate:this.formatDate('mm/dd/yy', record.ContributionRecurringBatch.next_run_date),
                            recurringType:record.ContributionRecurringBatch.recurring_interval+'-' + record.ContributionRecurringBatch.recurring_period,
                            currency: record.ContributionRecurringBatch.currency,
                            paymentMethodId:paymentMethodId,
                            recurringBatch:record.ContributionRecurringBatch,
                            batchActive: parseInt(record.ContributionRecurringBatch.active),
                            recurrings: recurrings,
                            paymentMethod: paymentRecord,
                            canHaveFee: (paymentRecord && paymentRecord.card_id) ? true : false,
                            isPayPal: isPayPal,
                            oldTotal: total
                        })
                    }
                } else if (data.errorInfo) {
                    this._error(data.errorInfo);
                }
            }).bind(this),
            error: (function (xhr, status, err) {
                this._error('Unknown error occurred');
            }).bind(this)
        });
    }

    getPaymentMethodDisplayValue(paymentMethod){
        var method = paymentMethod.PaymentProcessorMethod;

        // Add custom classes for different payment method (check/card) and cart type (visa, master, etc.)
        var cls = "payment-method method-type-" + method.type;
        if(paymentMethod.PaymentProcessorCard && paymentMethod.PaymentProcessorCard.card_type){
            cls += " card-type " + paymentMethod.PaymentProcessorCard.card_type.toLowerCase().replace(/ /g,"-");
        }

        var hiddenPart = method.check_id?'xxxxxxxxx':'xxxx xxxx xxxx ';

        return (<span className={cls}>
            <span className="hidden-part">{hiddenPart}</span><span className="last-four">{method.last_four}</span>
        </span>);
    }

    formatRecurrings(recurringData){
        var recurrings = [];

        recurringData.forEach(function(recurringItem){
            var index = this._recurringIndex++;
            
            recurrings[index]={
                id:recurringItem['id'],
                index:index,
                campaign_id:recurringItem.campaign_id,
                category_id:recurringItem.ContributionCampaign.category_id,
                amount:recurringItem.amount,
                is_anonymous:recurringItem.is_anonymous,
                use_fixed_recurring_amounts:recurringItem.use_fixed_recurring_amounts,
                is_fee_campaign: recurringItem.is_fee_campaign
            }
        }.bind(this));
        
        return recurrings;
    }

    close() {
        $(this.refs.modal).modal('hide');
    }

    show(record) {
        $(this.refs.modal).modal('show');
        
        this.setState({
            loading:true
        });
        
        this.load(record);
        
    }

    edit(record){
        this.show(record);  
    }

    addPayment(){
        window.location = this.props.editPaymentMethodURL+'?currency='+this.state.currency+'&redirect='+this.props.currentPageURL.replace(/\/recurring_batch_id:\d*/ig,'')+'/recurring_batch_id:'+this.state.recurringBatch['id'];
    }

    onAddDesignation(){
        var recurrings = this.state.recurrings;
        if(!recurrings){
            recurrings = [];
        }
        recurrings.push({
            index:this._recurringIndex++,
            id:''
        });
        
        this.setState({
            recurrings:recurrings
        })
    }

    onDesignationRemove(index){
        var recurrings = this.state.recurrings;
        delete recurrings[index];
        
        this.setState({
            recurrings:recurrings
        })
    }

    getTotal(){
        var total = 0;
        this.state.recurrings.forEach(function(item){
            var amount = parseFloat(item.amount);
            if(!isNaN(amount)){
                total+=amount;
            }
        }.bind(this));
        return total.toFixed(2);
    }

    onAmountChange(index,amount){
        var recurring = this.state.recurrings[index];
        recurring.amount = amount;
        
        this.adjustFee();
        
        this.setState({
            total:this.getTotal()
        })
    }
    
    getFee() {
        var state = this.state;
        var props = this.props;
        var total = 0;
        var fee = 0;

        this.state.recurrings.forEach(function (item, index) {
            if (!(item.is_fee_campaign && props.transactionFeePercent)) {
                var amount = parseFloat(item.amount);
                if (!isNaN(amount)) {
                    total += amount;
                }
            }else{
                fee = parseFloat(item.amount);
            }
        }.bind(this));
        
        if(fee){
            return fee;
        }

        return Math.round((props.transactionFeePercent / 100 * total) * 100) / 100;
    }

    adjustFee() {
        var props = this.props;
        var state = this.state;
        
        if(!state.canHaveFee){
            return;
        }
        
        var recurrings = this.state.recurrings;

        var total = 0;
        var feeIndex = null;

        this.state.recurrings.forEach(function (item, index) {
            if (item.is_fee_campaign && props.transactionFeePercent) {
                feeIndex = index;
            } else {
                var amount = parseFloat(item.amount);
                if (!isNaN(amount)) {
                    total += amount;
                }
            }
        }.bind(this));

        var originalFee = this.state.originalFee;
        var fee = this.state.fee;

        if (feeIndex != null && !isNaN(feeIndex)) {
            var recurringFee = recurrings[feeIndex];
            if (!originalFee) {
                originalFee = recurringFee.amount
            }
            fee = Math.round((props.transactionFeePercent / 100 * total) * 100) / 100;
            recurrings[feeIndex].amount = fee;

            var feeRef = this.refs['recurring_'+feeIndex];
            if(feeRef){
                feeRef.setState({
                    amount: fee
                })
            }
        }

        this.setState({
            recurrings: recurrings,
            originalFee: originalFee,
            fee: fee
        });

    }

    save(){
        var valid = true;
        var me = this;
        var campaignData = [];
        
        this.state.recurrings.forEach(function(item){
            var recurringGift = this.refs['recurring_'+item.index];
            if(recurringGift){
                valid = valid && recurringGift.validate();
            }
            campaignData.push(recurringGift.getValue());
        }.bind(this));

        var paymentMethodInValid = this.state.paymentMethodId?false:true;
        var recurringInValid = this.state.recurringType?false:true;

        if (this.state.isPayPal) {
            paymentMethodInValid = false;
        }
        
        this.setState({
            paymentMethodInValid:paymentMethodInValid,
            recurringInValid:recurringInValid
        });
        
        valid = valid && !paymentMethodInValid && !recurringInValid;
        
        if (this.state.isPayPal && this.getTotal() > this.state.oldTotal) {
            this._error('Total amount cannot be increased for recurring PayPal gifts');
            return;
        }
        
        if(valid){
            
            var data = {
                id:me.state.recurringBatch.id,
                active: me.state.batchActive,
                next_run_date:this.formatDate('yy-mm-dd', this.state.nextRunDate),
                recurring_end_date:this.formatDate('yy-mm-dd', this.state.endDate),
                recurring_type:this.state.recurringType,
                payment_processor_method_id:this.state.paymentMethodId,
                campaigns:campaignData
            };

            var saveFunction = function () {
                $.ajax({
                    url: SS.route('Contributions', 'ContributionRecurringBatches', 'save'),
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: data,
                    success: (function (data) {
                        if (data.success) {
                            $(me.refs.modal).modal('hide');
                            me.setState({
                                originalFee:null
                            })
                            me.props.grid.load();
                        } else if (data.errorInfo) {
                            me._error(data.errorInfo);
                        }
                    }).bind(this),
                    error: (function (xhr, status, err) {
                        me._error('Unknown error occurred');
                    }).bind(this)
                });
            };

            if (parseInt(this.state.recurringBatch.active) && !this.state.batchActive) {
                // Show cancellation confirmation
                new SS.customAlert({
                    title: 'Cancel Gift',
                    msg: 'Are you sure you want to cancel this gift?',
                    closeButton: true,
                    buttons: {
                        ok: {
                            btnText: 'Yes',
                            handler: function () {
                                saveFunction();
                            }
                        },
                        cancel: {
                            btnText: 'No'
                        }
                    }
                });
            } else if (this.state.originalFee && this.state.originalFee != this.state.fee) {
                // Show cancellation confirmation
                new SS.customAlert({
                    title: 'Recurring Updated',
                    msg: 'The Processing fee for this gift has been updated from '+ this.state.originalFee + ' to '+ this.state.fee
                        +'.<br /> The total amount is '+ this.getTotal(),
                    closeButton: true,
                    buttons: {
                        ok: {
                            btnText: 'Ok',
                            handler: function () {
                                saveFunction();
                            }
                        },
                        cancel: {
                            btnText: 'Cancel'
                        }
                    }
                });
            } else {
                // Normal save
                saveFunction();
            }

        }else{
            this._error('Please check for invalid fields');
        }
    }

    onRecurringChange(type){
        var state = this.state;
        
        this.setState({
            recurringType:type,
            recurringInValid:false
        },function (){
            if(this.isDisabledEdit()){
                return;
            }
            
            
            var campaignMapping = [];
            var campaignIds = [];

            state.recurrings.forEach(function (item){
                var ref = 'recurring_'+item.index;
                var campaignId = this.refs[ref].state.campaign_id;
                
                if(campaignId){
                    campaignIds.push(campaignId);

                    campaignMapping.push({
                        ref:ref,
                        campaign_id:campaignId
                    })
                }
            }.bind(this));
            
            campaignIds = campaignIds.join(',');

            $.ajax({
                url: SS.route('Contributions', 'ContributionCampaignCategoryRecurringFixedAmounts', 'getRecurringFixedAmounts', null),
                method: 'POST',
                dataType: 'json',
                cache: false,
                data: {
                    campaignId: campaignIds,
                    currency: this.state.currency,
                    recurringType: this.state.recurringType
                },
                success: (function (data) {
                    if (data.fixedRecurringAmounts) {
                        campaignMapping.forEach(function (item){
                            var fixedAmount = data.fixedRecurringAmounts[item.campaign_id];
                            var ref = this.refs[item.ref];
                            if(fixedAmount){
                                ref.setState({
                                    amount:fixedAmount,
                                    disabledAmount:true
                                })
                                
                                if(!this._warnedRecurringChange){
                                    this._warnedRecurringChange = true;
                                    
                                    this._error('Changing Recurring Type also modifies amounts on some of your designations');
                                }
                            }
                        }.bind(this))
                    }
                }).bind(this)
            });
        })
    }

    onMethodChange(method){
        
        this.setState({
            canHaveFee: method.card_id?true:false,
            paymentMethodId:method?method.id:null,
            paymentMethodInValid:(method?method.id:null)?false:true
        },function (){
            if(method.card_id){
                this.adjustFee();
            }
        }.bind(this))
    }
    
    isDisabledEdit(){
        return this.state.recurringBatch && !parseInt(this.state.recurringBatch.active) && this.props.disableCanceledEdit;
    }

    onFeeToggle(enable){
        var state = this.state;
        var props = this.props;
        var recurrings = state.recurrings;


        if(enable){
            if(!recurrings){
                recurrings = [];
            }
            recurrings.push({
                index:this._recurringIndex++,
                id:'',
                campaign_id: props.transactionFeeCampaignId,
                is_fee_campaign: true,
                amount: this.getFee()
            });

            this.setState({
                recurrings:recurrings
            })
        }else{
            var feeIndex = null;
            recurrings.forEach(function (item, index) {
                if (item.is_fee_campaign && props.transactionFeePercent) {
                    feeIndex = index;
                }
            }.bind(this));

            if (feeIndex != null && !isNaN(feeIndex)) {
                delete recurrings[feeIndex];
            }
            
            this.setState({
                recurrings: recurrings,
                originalFee: null,
                fee: null
            })
        }
        
    }

    render() {
        var props = this.props;
        var state = this.state;
        
        var fullname = undefined;
        
        if(state.person){
            fullname = <h6 key="person_name">{state.person.fullname}</h6>
        }
        
        var addPayment = props.editPaymentMethodURL?
            <span className="btn-group add-payment-method">
                <button className="btn btn-primary" onClick={this.addPayment.bind(this)} ><i className="fa fa-plus" /> </button>
            </span>:undefined;

        var leftSide = <button type="button" className="btn btn-secondary" onClick={this.close.bind(this)}>Close</button>;

        var disableEdit = false;
        var disableEditMessage = <div className="pull-right inactive-message">You cannot modify a canceled recurring
            gift.</div>;

        if(state.recurringBatch && !parseInt(state.recurringBatch.active)) {
            if(this.props.disableCanceledEdit){
                disableEdit = true;
                addPayment = false;
            }
        }
        
        var recurringGifts = [];
        
        if(state.recurrings){
            var recurringCount = 0;
            state.recurrings.forEach(function(item){
                recurringCount++;
            });
            
            
            var feeCampaign = undefined;
            var feeAmount = undefined;
            
            
            state.recurrings.forEach(function(item){
                
                var disabledRecurringEdit = this.props.disableDesignationEdit || disableEdit
                var disabledAmount = disableEdit || item.use_fixed_recurring_amounts;
                
                
                if(state.lockedCategoryIds && state.lockedCategoryIds.indexOf(item.category_id) >-1){
                    disabledRecurringEdit = disabledAmount = true;
                }
                
                if(state.canHaveFee && item.is_fee_campaign && props.transactionFeePercent){
                    feeCampaign = <ContributionsReactRecurringGift
                        is_fee_campaign={true}
                        id={item.id}
                        key={'recurring_'+item.index}
                        ref={'recurring_'+item.index}
                        index={item.index}
                        onAmountChange={this.onAmountChange.bind(this)}
                        onRemove={this.onDesignationRemove.bind(this)}
                        amount={item.amount}
                        campaign_id= {item.campaign_id}
                        is_anonymous={item.is_anonymous}
                        hasRemove={recurringCount>1}
                        editWindow={this}
                        currency = {state.currency}
                        recurringType = {state.recurringType}
                        disabled={true}
                        disabledAmount={true}
                    />
                }else{
                    recurringGifts.push(
                        <ContributionsReactRecurringGift
                            id={item.id}
                            key={'recurring_'+item.index}
                            ref={'recurring_'+item.index}
                            index={item.index}
                            onAmountChange={this.onAmountChange.bind(this)}
                            onRemove={this.onDesignationRemove.bind(this)}
                            amount={item.amount}
                            campaign_id= {item.campaign_id}
                            is_anonymous={item.is_anonymous}
                            hasRemove={recurringCount>1}
                            editWindow={this}
                            currency = {state.currency}
                            recurringType = {state.recurringType}
                            disabled={disabledRecurringEdit}
                            disabledAmount={disabledAmount}
                        />
                    );
                }
                
            }.bind(this))
            
            if(feeCampaign){
                recurringGifts.push(feeCampaign);
            }
        }
        
        var feeToggle = null;
        
        if(state.canHaveFee && props.transactionFeePercent){
            feeToggle = <ContributionsReactRecurringFeeToggle
                amount={this.getFee()}
                onFeeToggle={this.onFeeToggle.bind(this)}
                ref="fee_toggle"
                enabled={feeCampaign? true: false}
                description = {props.feeDescription?props.feeDescription:''}
            />;
        }
        
        var methodOptions = [];
        if(state.currency){
            state.paymentMethodOptions.forEach(function (method){
                if(state.currency == method.props['data-currency']){
                    methodOptions.push(method);
                }
            });
        }else{
            methodOptions = state.paymentMethodOptions;
        }

        return (
            <div className={"modal"+(state.loading?" loading":"")} ref="modal" >
                <div className="modal-dialog modal-lg" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" >
                                <span >&times;</span>
                            </button>
                            <h4 className="modal-title">{props.title}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="col-md-5 col-donation-info">
                                    <div className="row row-fullname">
                                        {fullname}
                                    </div>
                                    <div className="row row-donation-info">
                                        <div className="form-group start-date">
                                            <label htmlFor="recurring_start_date">Start Date</label>
                                            <div className="field-holder field-with-icon-holder">
                                                <input type="text" value={state.startDate} className="form-control" name="recurring_start_date" ref="startDate" disabled={true} />
                                            </div>
                                        </div>
                                        <div className="form-group next-run-date">
                                            <label htmlFor="recurring_next_run_date">Next Run Date</label>
                                            <div className="field-holder field-with-icon-holder calendar input-datepicker-holder">
                                                <input type="text" value={state.nextRunDate} className="form-control" name="recurring_next_run_date" ref="nextRunDate" disabled={disableEdit || state.isPayPal} />
                                            </div>
                                        </div>
                                        <div className="form-group end-date">
                                            <label htmlFor="recurring_end_date">End Date</label>
                                            <div className="field-holder field-with-icon-holder calendar input-datepicker-holder">
                                                <input type="text" value={state.endDate} className="form-control" name="recurring_end_date" ref="endDate" disabled={disableEdit} />
                                            </div>
                                            {state.endDate && <i onClick={(event) => {this.setState({endDate: null})}}/>}
                                        </div>
                                        <div className={"form-group recurring-types"+ ( state.recurringInValid?' has-error':'')}>
                                            <label className="clearfix">{this.props.recurringTypeLabel}</label>
                                            <div className="field-holder field-dropdown">
                                                <div className="btn-group">
                                                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={disableEdit || this.props.disableFrequencyEdit || state.isPayPal}>
                                                        <span>{state.recurringTypeLabel}</span>
                                                    </button>
                                                    <div className="dropdown-menu">
                                                        {state.recurringTypeOptions}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"form-group payment-methods add-payment-" + (addPayment?'yes':'no') + ( state.paymentMethodInValid?' has-error':'') + " payment-methods-" + (methodOptions.length <= 0?'empty':'available')}>
                                            <label className="clearfix">{this.props.paymentMethodLabel}</label>
                                            {!state.isPayPal && <div className="field-holder field-dropdown">
                                                <div className="btn-group select-payment-method">
                                                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={disableEdit}>
                                                        {state.paymentMethodLabel}
                                                    </button>
                                                    <div className="dropdown-menu">
                                                        {methodOptions}
                                                    </div>
                                                </div>
                                                {addPayment ? addPayment : undefined}
                                                <div className="clearfix"></div>
                                            </div>}

                                            {state.isPayPal &&
                                                <button type="button" className="btn btn-primary" disabled={true}>PayPal</button>
                                            }

                                            {methodOptions.length <= 0 ? (
                                                <div className="no-payment-methods-message">No Payment Methods Available</div>
                                            ) : undefined}
                                        </div>

                                        <div className="form-group status">
                                            <label className="clearfix">Change Status</label>
                                            <div className="field-holder field-dropdown">
                                                <div className="btn-group">
                                                    <button type="button" className="btn btn-primary dropdown-toggle"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false" disabled={disableEdit}>
                                                        {state.batchActive ? <span>Active</span> :
                                                            <span>Canceled</span>}
                                                    </button>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" onClick={(event) => {
                                                            this.setState({batchActive: 1})
                                                        }}>Active</a>
                                                        <a className="dropdown-item" onClick={(event) => {
                                                            this.setState({batchActive: 0})
                                                        }}>Canceled</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7 col-designations">
                                    <h6>Designations</h6>
                                    <div className="designations-content">
                                        <div className="recurring-gifts">
                                            {recurringGifts}
                                        </div>
                                        {feeToggle}
                                        <div className="designations-bottom text-right clearfix">
                                            <h4><span className="total-label">Total: $</span><span className="total-value">{this.getTotal()}</span></h4>
                                            {(!this.props.disableDesignationEdit && !disableEdit)?
                                                <button type="button" className="btn btn-primary btn-lg btn-block add-designation" onClick={this.onAddDesignation.bind(this)}>Add Another Designation</button>
                                            :undefined}
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            
                        </div>
                        <div className="modal-footer">
                            <div className="pull-left">
                                {leftSide}
                            </div>
                            {!disableEdit?
                            <div className="pull-right">
                                <button type="button" className="btn btn-primary" onClick={this.save.bind(this)}>Save gift</button>
                            </div>:disableEditMessage}
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

ContributionsReactRecurringRecord.propTypes = {
    editRecurringBatchId: PropTypes.any,
    grid: PropTypes.object.isRequired,
    currentPageURL: PropTypes.any.isRequired,
    editPaymentMethodURL: PropTypes.any.isRequired,
    title: PropTypes.any
};

ContributionsReactRecurringRecord.defaultProps = {
    title: 'Edit Recurring Donation',
    recurringTypeLabel: 'Recurring Type',
    paymentMethodLabel: 'Payment Method',
    disableDesignationEdit: false,
    disableCanceledEdit: false
};

class ContributionsReactRecurringGift extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: props.amount,
            is_anonymous: props.is_anonymous,
            campaign_id: props.campaign_id,
            editWindow: props.editWindow,
            disabledAmount : props.disabledAmount,
            id: props.id
        };
    }
    componentWillReceiveProps(nextProps) {
        if(this.props.disabledAmount != nextProps.disabledAmount){
            this.setState({
                disabledAmount: nextProps.disabledAmount
            })
        }
    }

    getValue(){
        return{
            id:this.state.id,
            campaign_id:this.state.campaign_id,
            amount:this.state.amount,
            is_anonymous:this.state.is_anonymous?1:0,
            is_fee_campaign: this.props.is_fee_campaign
        }
    }

    onRemove(){
      if(this.props.onRemove){
          this.props.onRemove(this.props.index);
      }  
    }
    
    numDecimals(amount){
        var numParts = amount.toString().split(".");
        
        if(numParts && numParts[1]){
            return numParts[1].length;
        }
        
        return 0;
        
    }

    onAmountChange(event){
        
        var originalAmount = event.target.value;
        
        
        var amount = Math.abs(parseFloat(originalAmount));


        var numDecimals = this.numDecimals(originalAmount);
        
        if(numDecimals>2){
            amount = amount.toFixed(2);
        }
        
        if(this.props.onAmountChange){
            this.props.onAmountChange(this.props.index, amount);
        }
        
        this.setState({
            amount: amount
        })
    }

    onCampaignChange(value){
        var record = this.refs["campaign_dd"].getRecordById(value);
        
        var useForceRecurring = record.getIn(['ContributionCampaignCategory','use_fixed_recurring_amounts']);
        
        this.setState({
            campaign_id:value,
            disabledAmount: this.props.disabled
        },function (){
            if(useForceRecurring){
                this.getFixedRecurringAmount(value);
            }
        })
    }
    
    getFixedRecurringAmount(campaignId){
        
        $.ajax({
            url: SS.route('Contributions', 'ContributionCampaignCategoryRecurringFixedAmounts', 'getRecurringFixedAmounts', null),
            method: 'POST',
            dataType: 'json',
            cache: false,
            data: {
                campaignId: campaignId,
                currency: this.props.currency,
                recurringType: this.props.recurringType
            },
            success: (function (data) {
                if (data.fixedRecurringAmounts) {
                    
                    var fixedAmount = data.fixedRecurringAmounts[campaignId];
                    
                    if(fixedAmount){
                        this.setState({
                            amount: fixedAmount,
                            disabledAmount: true
                        })
                    }
                }
            }).bind(this),
            error: (function (xhr, status, err) {
                this._error('Unknown error occurred');
            }).bind(this)
        });
    }

    validate(){
        var amountInvalid = false;
        var campaignInvalid = false;
        if(!this.state.amount || isNaN(parseFloat(this.state.amount)) || (!this.props.is_fee_campaign && parseFloat(this.state.amount)<1)){
            amountInvalid = true;
        }

        if(!this.state.campaign_id){
            campaignInvalid = true;
        }
        
        
        this.setState({
            amountInvalid:amountInvalid,
            campaignInvalid:campaignInvalid
        });
        
        return !amountInvalid && !campaignInvalid;
    }

    onAnonymous(event){
        this.setState({
            is_anonymous:event.target.checked
        })
    }

    render(){
        var state = this.state;
        var props = this.props;
        var removeBtn = undefined;
        
        if(this.props.hasRemove && !this.props.disabled){
            removeBtn = <button type="button" className="close" onClick={this.onRemove.bind(this)}>
                <span>&times;</span>
            </button>
        }
        
        var amount = state.amount;
        var actions = null;
        
        if(!props.is_fee_campaign){
            actions = <div className="col-md-4 col-actions">
                <div className="form-check-inline p-t checkbox-holder is-anonymous">
                    <label className="c-input c-checkbox">
                        <input disabled={this.props.disabled} type="checkbox" onChange={this.onAnonymous.bind(this)}
                               checked={!!state.is_anonymous}/>
                        <span className="c-indicator"/>
                        <span className="c-label">Anonymous</span>
                    </label>
                </div>
                {removeBtn}
            </div>
        }
        
        
        return (
            <div className={"recurring-gift remove-" + (this.props.hasRemove?"yes":"no")}>
                <div className="row">
                    <div className="col-md-5 p-r-0 col-campaign">
                        <div className={"form-group"}>
                            <ReactFieldDropdown
                                allowClear = {false}
                                ref="campaign_dd"
                                placeholder="Search..."
                                idPath={['ContributionCampaign', 'id']}
                                displayPath={['ContentItem', 'name']}
                                url={SS.route('Contributions','ContributionCampaigns','getAll')}
                                urlParams={{limit: 10, simple:1, published: 1, searchable: 1}}
                                search={true}
                                onChange={this.onCampaignChange.bind(this)}
                                value={this.state.campaign_id}
                                autoLoadFirstId={true}
                                hasError={this.state.campaignInvalid}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 p-r-0 col-amount">
                        <div className={"form-group amount"+(this.state.amountInvalid?' has-error':'')}>
                            <div className="field-holder">
                                <input type="number" value={amount} className="form-control" placeholder="Amount" name="amount" ref="amount" onChange={this.onAmountChange.bind(this)} disabled={state.disabledAmount}/>
                            </div>
                        </div>
                    </div>
                    {actions}
                </div>
            </div>
        )
    }
}

ContributionsReactRecurringGift.propTypes = {
    onRemove: PropTypes.func,
    onAmountChange: PropTypes.func,
    hasRemove: PropTypes.bool,
    index: PropTypes.number,
    disabled: PropTypes.bool
};

ContributionsReactRecurringGift.defaultProps = {
    id: ''
};


class ContributionsReactRecurringFeeToggle extends React.Component {

    constructor(props) {
        super(props);
    }

    onFeeToggle(event){
        if(this.props.onFeeToggle){
            this.props.onFeeToggle(event.target.checked);
        }
    }

    render(){
        var state = this.state;
        var props = this.props;
        
        var description = undefined;
        
        if(props.description){
            description = <div className="fee-description">{props.description}</div>
        }
        
        var amountFormatted = props.amount.toFixed(2);
        
        return (
            <div className={"recurring-fee-toggle"}>
                {description}
                <div className="fee-toggle-wrap">
                    <div className="form-check-inline p-t checkbox-holder is-anonymous">
                        <label className="c-input c-checkbox">
                            <input type="checkbox" onChange={this.onFeeToggle.bind(this)} checked={props.enabled}/>
                            <span className="c-indicator"/>
                            <span className="c-label">Opt in for a fee of ${amountFormatted}</span>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}


class ContributionsReactRecurringFee extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: props.amount,
            is_anonymous: props.is_anonymous,
            campaign_id: props.campaign_id,
            editWindow: props.editWindow,
            disabledAmount : props.disabledAmount,
            id: props.id
        };
    }

    validate(){
        return true;
    }
    
    getValue(){
        return{
            id:this.state.id,
            amount: this.props.amount,
            campaign_id:this.state.campaign_id,
            is_anonymous:this.state.is_anonymous?1:0,
            is_fee_campaign: true
        }
    }

    onRemove(){
        if(this.props.onRemove){
            this.props.onRemove(this.props.index);
        }
    }


    render(){
        var state = this.state;
        var props = this.props;
        var removeBtn = undefined;

        if(this.props.hasRemove && !this.props.disabled){
            removeBtn = <button type="button" className="close" onClick={this.onRemove.bind(this)}>
                <span>&times;</span>
            </button>
        }

        return (
            <div className={"recurring-gift remove-" + (this.props.hasRemove?"yes":"no")}>
                <div className="row">
                    <input type="hidden" value = {this.state.campaign_id} />
                    <div className="col-md-8 col-sm-8 p-r-o"></div>
                    <div className="col-md-3 p-r-0 col-amount">
                        <div className={"form-group amount"}>
                            <label>Processing Fee</label>
                            <div className="field-holder">
                                <input type="text" readOnly={true} value={props.amount} className="form-control" placeholder="Amount" name="amount" ref="amount"  disabled={state.disabledAmount}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 col-actions">
                        {removeBtn}
                    </div>
                </div>
            </div>
        )
    }
}

ContributionsReactRecurringFee.propTypes = {
    onRemove: PropTypes.func,
    hasRemove: PropTypes.bool,
    disabled: PropTypes.bool
};

ContributionsReactRecurringGift.defaultProps = {};
